module.exports = __webpack_public_path__ + "img/sign.e79af35b.svg";